import { TransText } from '@/i18n/trans/text';
import type { InventoryClass } from '@/utils/purchase';
import { Divider, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-aria-components';

interface InventoryClassTabsProps {
  tabs: ReadonlyArray<InventoryClass>;
  legId: string;
  /** Already resolved to one of `tabs` by the caller */
  value?: InventoryClass;
  onChange: (legId: string, inventoryClass: InventoryClass) => void;
}

const InventoryClassTabs: FC<InventoryClassTabsProps> = ({
  tabs,
  legId,
  value,
  onChange,
}) => {
  if (tabs.length < 2 || !value) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <ToggleButtonGroup
        selectionMode="single"
        disallowEmptySelection
        selectedKeys={[value]}
        onSelectionChange={(keys) => {
          const [key] = [...keys];
          const next = tabs.find((tab) => tab === key);
          if (next) {
            onChange(legId, next);
          }
        }}
        className="flex gap-6"
      >
        {tabs.map((tab) => (
          <div key={tab} className="flex flex-col gap-0.5">
            <ToggleButton
              id={tab}
              data-testid={`inventory-class-tab-${tab}`}
              className="text-medium data-[selected]:text-primary"
            >
              <Typography variant="body1-bold">
                <TransText i18nKey={tab} />
              </Typography>
            </ToggleButton>
            {value === tab && (
              <span className="mt-2 rounded-t-full bg-primary p-[0.1em]" />
            )}
          </div>
        ))}
      </ToggleButtonGroup>
      <Divider orientation="horizontal" variant="medium" />
    </div>
  );
};

export default InventoryClassTabs;
